module.exports = __webpack_public_path__ + "img/badgeOnGoingLine.c036e635.svg";